<script>
	import { slide } from 'svelte/transition';

	export let transactions = [];

	let showTransactions = false;
</script>

<div transition:slide|local style="margin-top: 20px;">
	<button class="btn btn-primary btn-sm" on:click|preventDefault={() => (showTransactions = !showTransactions)}>
		{showTransactions ? 'Hide' : 'Show'} Transactions
	</button>

	<div style="display: {showTransactions ? 'block' : 'none'}; margin-top: 10px">
		<div class="row header">
			<div class="fixWidth" style="flex:1.5;">
				<div class="small-font">Transaction Date</div>
			</div>
			<div class="fixWidth" style="flex:1; text-align:center;">
				<div class="small-font">Transaction Type</div>
			</div>
			<div class="fixWidth" style="flex:0.9; text-align:right;">
				<div class="small-font">No. of Shares</div>
			</div>
			<div class="fixWidth" style="flex:0.9; text-align:right;">
				<div class="small-font">Price per Share $</div>
			</div>
			<div class="fixWidth" style="flex:0.9; text-align:right;">
				<div class="small-font">Brokerage $</div>
			</div>
		</div>
		{#each transactions as transaction, i}
			<div class="row">
				<div class="fixWidth" style="flex:1.5;">
					{transaction.TransactionDate || ''}
				</div>
				<div class="fixWidth" style="flex:1; text-align:center;">
					{transaction.TransactionType || ''}
				</div>
				<div class="fixWidth" style="flex:0.9; text-align:right;">
					{transaction.NumberOfShares || ''}
				</div>
				<div class="fixWidth" style="flex:0.9; text-align:right;">
					{transaction.PricePerShare?.toFixed(2) || ''}
				</div>
				<div class="fixWidth" style="flex:0.9; text-align:right;">
					{transaction.Brokerage?.toFixed(2) || ''}
				</div>
			</div>
		{/each}
	</div>
</div>

<style>
	.row {
		margin: 0;
	}
	.row.header {
		font-weight: 300;
		background-color: #f8f9fa;
		border-bottom: 1px solid #dee2e6;
	}
	.fixWidth {
		font-size: 0.85rem;
		padding: 4px 20px;
	}
</style>
